import React from "react";
import SellersView from "../Components/dashboard/SellersView";

const Sellers = () => {
  return <SellersView />;
};

export default Sellers;
